module.exports = __webpack_public_path__ + "va.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/va.svg
// module id = 1129
// module chunks = 0